import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto } from "../../../../../autogen/bff-api";
import { StepNavigation } from "../../../../../common/StepNavigation";
import { EventAboutSection } from "../../view-single/EventAboutSection";
import { EventBuyerInfo } from "../../view-single/EventBuyerInfo";
import { EventContractDetails } from "../../view-single/EventContractDetails";
import { EventDeadlineHighlight } from "../../view-single/EventDeadlineHighlight";
import { EventDesignContestSection } from "../../view-single/EventDesignContestSection";
import { EventDocumentsSection } from "../../view-single/EventDocumentsSection";
import { useDesignContestEntry } from "../designContestEntry";

interface Props {
  event: PortalSourcingEventDetailDto;
  nextStep?: () => void;
  nextStepLabel?: string;
}

export const BidIntroStep = ({ event, nextStep, nextStepLabel }: Props) => {
  const { t } = useTranslation();
  const designContest = useDesignContestEntry();

  return (
    <Box pb="8" pt="6">
      <Stack spacing="2" mb="6">
        <Heading size="md">{t("About the procurement")}</Heading>
        <Text fontSize="sm" color="smMuted">
          {designContest
            ? t("Review the key details before you start building your entry.")
            : t("Review the key details before you start building your offer.")}
        </Text>
      </Stack>

      <Stack spacing="6" mb="8">
        <EventDeadlineHighlight event={event} />
        <EventAboutSection event={event} showAwardCriteria={true} />
        <EventDesignContestSection event={event} />
        <EventContractDetails event={event} />
        <EventDocumentsSection event={event} />
        <EventBuyerInfo event={event} />
      </Stack>

      <StepNavigation onNext={nextStep} nextLabel={nextStepLabel} />
    </Box>
  );
};
